// src/pages/ChildSafety.js 
// (Assuming this file contains your ChildSafety component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar';
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';

// Page Component
import ChildSafety_PG_Content from './PageComponent/ChildSafety_PG_Content';

function ChildSafety() {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>Child Safety | Marvel Blinds</title>
                <meta
                    name="description"
                    content="Keep your child safe at home and outdoors. Explore tips and products that make safety easy. Visit now for essential advice!"
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/child-safety/`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Child Safety" />
                <meta
                    property="og:description"
                    content="Keep your child safe at home and outdoors. Explore tips and products that make safety easy. Visit now for essential advice!"
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/child-safety/`} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <div>
                <Navbar />
                <NotificationBar />
                <ChildSafety_PG_Content />
                <Footer />
            </div>
        </>
    );
}

export default ChildSafety;